module.exports = __webpack_public_path__ + "fonts/junction-light.fa0ccd38.eot";